module.exports = __webpack_public_path__ + "static/media/editor.ce836f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/environment/editor.png
// module id = 57
// module chunks = 0